import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { CheckCircle, Phone, ArrowRight, Trophy, Sparkles } from 'lucide-react';

const EXAM_PROGRAMS = [
  { name: 'RBI Grade B', tagline: 'Phase 1 + Phase 2 + Interview', popular: true },
  { name: 'SBI PO', tagline: 'Prelims + Mains + GD/PI', popular: true },
  { name: 'IBPS PO', tagline: 'Prelims + Mains + Interview' },
  { name: 'SSC CGL', tagline: 'Tier 1 + Tier 2 Complete' },
  { name: 'SSC CHSL', tagline: 'Tier 1 + Tier 2 + Typing' },
  { name: 'IB ACIO', tagline: 'Tier 1 + Tier 2 + Interview' },
  { name: 'NABARD Grade A', tagline: 'Phase 1 + Phase 2 + Interview' },
  { name: 'IBPS Clerk', tagline: 'Prelims + Mains' },
];

const EnrollNow = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero */}
      <section className="bg-gradient-to-br from-red-700 via-red-600 to-orange-600 text-white py-14" data-testid="enroll-hero">
        <div className="container mx-auto px-4 max-w-5xl text-center">
          <Badge className="bg-yellow-400 text-gray-900 mb-3 animate-pulse">🔥 LIMITED SEATS — New Batch Starting Soon</Badge>
          <h1 className="text-3xl md:text-5xl font-bold mb-3" data-testid="enroll-h1">Enroll Now at VIDYA365 Delhi</h1>
          <p className="text-lg text-red-100 mb-6 max-w-3xl mx-auto">
            Secure your seat in India's most trusted SSC, Banking & RBI Grade B coaching. 500+ selections, 4.6★ rating.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/student/register"><Button data-testid="enroll-register-btn" className="bg-white text-red-700 hover:bg-red-50 font-semibold px-6 py-5">Register Online</Button></Link>
            <a href="tel:+918504110365"><Button data-testid="enroll-call-btn" variant="outline" className="bg-transparent border-white text-white hover:bg-white/10 px-6 py-5"><Phone size={16} className="mr-2" /> +91 85041 10365</Button></a>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-2xl font-bold mb-6 text-center">Everything You Get When You Enroll</h2>
          <div className="grid md:grid-cols-3 gap-4">
            {[
              'Live + Recorded classes by expert faculty',
              'Adda247-style mock test series (100+ mocks)',
              'Updated study material (English + Hindi)',
              '24x7 Guruji AI doubt-bot + daily live doubt sessions',
              'Free typing test platform (SSC/Bank pattern)',
              'AI Mock Interview for RBI/SBI/IBPS/IB ACIO',
              'PYQ Library — last 10 years of papers',
              'Personal mentor + weekly progress reviews',
              'Interview prep with ex-bankers / IB officers',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-2 bg-red-50 p-3 rounded-lg border border-red-100">
                <CheckCircle className="text-green-600 flex-shrink-0 mt-1" size={18} />
                <p className="text-sm text-gray-800">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Programs */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-2xl font-bold mb-6 text-center">Choose Your Program</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {EXAM_PROGRAMS.map((p) => (
              <Card key={p.name} className="hover:shadow-md transition-shadow">
                <CardContent className="p-4 flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="font-bold">{p.name}</h3>
                      {p.popular && <Badge className="bg-yellow-400 text-gray-900 text-[10px]">POPULAR</Badge>}
                    </div>
                    <p className="text-xs text-gray-500">{p.tagline}</p>
                  </div>
                  <Link to="/student/register">
                    <Button size="sm" data-testid={`enroll-program-${p.name.toLowerCase().replace(/ /g, '-')}`} className="bg-red-600 hover:bg-red-700">Enroll <ArrowRight size={14} className="ml-1" /></Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 bg-red-600 text-white">
        <div className="container mx-auto px-4 max-w-3xl text-center">
          <Trophy className="mx-auto mb-2" size={40} />
          <h2 className="text-2xl md:text-3xl font-bold mb-3">Don't Miss This Batch</h2>
          <p className="mb-6">Seats fill in days. Lock yours today and join 500+ Vidya365 selections.</p>
          <Link to="/student/register"><Button data-testid="enroll-bottom-cta" className="bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-bold px-8 py-5"><Sparkles className="mr-2" size={16} /> Register Now</Button></Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EnrollNow;
